import { BeatblipUtils } from './../../consts/beatblip-utils';
import { DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ChartColor, ChartDataSets, ChartOptions, ChartType } from 'chart.js';
import { Label } from 'ng2-charts';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationDialogService } from 'src/app/test/test-step/confirmation-dialog.service';
import { ProjectService } from 'src/app/_services/project.service';
import { ReportService } from 'src/app/_services/report.service';
import { TestService } from 'src/app/_services/test.service';
import { Chart } from '../latest-report/chart';
import { Location } from '@angular/common';
import { beatBlipSubscriptionConsts } from 'src/app/consts/beatBlipSubscriptionConsts';
import { HomeService } from 'src/app/_services/home.service';

@Component({
  selector: 'app-test-result-summary',
  templateUrl: './test-result-summary.component.html',
  styleUrls: ['./test-result-summary.component.scss']
})
export class TestResultSummaryComponent implements OnInit {

  projectId: any;
  projectReportData: any;
  projectData: Object;
  projectName: any;
  reportId: string;
  testDataId: string;
  path: string;
  title: string;
  pageTitle: any;
  status: string;
  reportForNavBar: string;
  iteration= 0;
  testSuiteReportData: Object;
  total: any;
  public barChartColors: ChartColor[] = [
    'rgb(92, 184, 92)',
    'rgb(217, 83, 79)',
    'rgb(236, 59, 15)',
    'rgb(240, 173, 78)',
     'rgb(91, 192, 222)', 
     'rgb(102, 205, 170)'
  ]
  public barChartOptions: ChartOptions = {
    responsive: true,
    maintainAspectRatio: true,
    legend: {
      display: true,
      position: 'bottom',
    },
    plugins: {
      labels: {
        render: 'percentage',
        fontColor: ['white'],
        precision: 2
      }
    }

  };
  charData: any=[];
  public chartOptionSelect = ['pie','bar'];
  public barChartLabels: Label[];
  public barChartType: ChartType = 'pie';
  public barChartLegend = true;
  public barChartPlugins = [];
  public barChartData: ChartDataSets[]=[];
  public pieColor: ChartColor[]=[];
  chartList: Array<Chart> = [];
  blinkArry: any[]=[];
  numarray: Array<Number>=[];
  testLabels: any[] = [];
  type: any;
  failureLogs: Array<any> = [];
  failShow: boolean;
  result: any[] =[];
  auditLogs: any;
  failReasonList: any[]=[];
  map = new Map();
  pagesSize = beatBlipSubscriptionConsts.pagesSize;
  perpageitem = beatBlipSubscriptionConsts.perpageitem;
  selectedPage: any;
  headerOptions = {
    showSetting : true,
    showSearch: false,
    heading : 'Latest Execution Report',
    data: undefined,
  }
  dataIterationIndex: string;


  constructor(
    private report: ReportService,
    private project: ProjectService,
    private testService:TestService,
    private formBuilder: UntypedFormBuilder,
  private http: HttpClient,
  private route: ActivatedRoute,
  private toastrService:ToastrService,
  private confirmationDialogService:ConfirmationDialogService,
  private utils: BeatblipUtils,
  private location: Location,
  private router: Router,
  private homeService: HomeService,
  @Inject( DOCUMENT ) private document: Document,
  ) { }

  ngOnInit() {
    this.route.paramMap.subscribe(
      params => {
        //:pid/:reportId/:testDataId/:path/:title/:iteration/:status
        this.projectId = params.get('pid');
        this.reportId = params.get('reportId');
        this.testDataId = params.get('testDataId');
        this.path = params.get('path');
        this.title =params.get('title');
        this.status = params.get('status');
        this.dataIterationIndex = params.get('iteration')
        //console.log('params',this.route.paramMap);
        //console.log('reportId',this.reportId);
        //console.log('testDataId',this.testDataId,'this.title ' );

        
        if(this.status=='/latest'){
          this.reportForNavBar = 'Latest Execution Report'
        }else{
          this.reportForNavBar = 'Historical Report'
        }
        //console.log(this.status);
        //console.log(this.reportForNavBar);
       this.project.getProjectById(this.projectId).subscribe(
         (data) => {
           this.projectData = data;
           this.headerOptions.data = {
             projectId: this.projectId,
             projectName: data['projectName']
           };
           //set header details
           this.homeService.setHeaderOptions(this.headerOptions);
           //console.log('projectData',this.projectData);
           
          //  this.testService.getTestSuiteTestReport(this.projectId,this.reportId,this.testDataId,this.path,this.title).subscribe(
          //   (data)=>{
          //     this.testSuiteReportData = data;
          //     //console.log('data',data);
          //     //console.log('this.testSuiteReportData', this.testSuiteReportData);
              
          //   }
          // )
          this.getTestSuiteTestReport(this.projectId,this.reportId,this.testDataId,this.path,this.title);
          //  this.projectName = this.projectData.projectName
         }
       )
       
      }
    )
}




verifyErrorMsg = function (msg) {
  var errorText = new Array();
  errorText.push('Error in performing the action');
                    errorText.push('Exception due to');
                    errorText.push('Verification error');
                    errorText.push('Error in locating the element');
                    errorText.push('Error Occurred');
                    errorText.push('Error: Error in processing the command');
                    errorText.push('InvokeTest error');
                    errorText.push('Error: Function is not supported');
                    errorText.push('Could not locate the elements');
                    errorText.push('-Expected:');
                    errorText.push('-Element expected to be');
                    errorText.push('Could not find event within Time');
  for (var i = 0; i < errorText.length; i++) {
      if (msg.indexOf(errorText[i]) !== -1) {
          return "bgRed";
      }
  }
  return "bgWhite";

};

failureReason(value:boolean){
  this.failShow = value;
  if(value){
    let i = 0;
    for(let f of this.testSuiteReportData['testCaseSummaryReport']){
      //console.log(this.testSuiteReportData['testCaseSummaryReport']);
      
      i++;
      this.testService.getTestCaseTestReport(this.projectId,this.reportId,f.testDataId,f.path, f.dataIterationIndex).subscribe((data) => {
       //console.log('data fail',data);

       var testStepReport = data['testStepReport'];
       

     

       
       
       
        if(data){
          var arrayData = new Array();
          var object = new Object();
          object['key'] = f.testDataId;
          // this.failureLogs.push(data);
          var testStepReport = data['testStepReport'];
          if(testStepReport){
            for(var i = 0; i < testStepReport.length; i++){
              var step = testStepReport[i];
  
              if (step.resultState.status !== 'PASS' && step.resultState.status !== 'NOTRUN' && step.resultState.status !== 'SKIPPED') {
                arrayData.push('Step: ' + (i + 1) + ' become ' + step.resultState.status);
                // this.failReasonList.push('Step: '+(i+1)+' become ' + step.resultState.status);  
                if (step.auditInfoS) {
                  for (var j = 0; j < step.auditInfoS.length; j++) {
                    var tempData = step.auditInfoS[j]
                    //console.log('temData',tempData);
                    if(tempData.toString().includes('Error')){
                      // this.failReasonList.push(tempData);
                      arrayData.push(tempData);
                    }
                }
                }
              }
            }
            //console.log('arrayData',arrayData);
            
            object['value'] = arrayData;

            this.failReasonList.push(object);
            //console.log('auditInfoData',this.failReasonList);
          }
          
          
          
          
          //console.log('arrayData',this.failReasonList);
        }
        
        // //console.log('fail logs',this.failureLogs[0].resultState.status);
        // var id =  this.failureLogs.filter(item => item.resultState.status==='INCONCLUSIVE');
        // //console.log('id',id);
        
        // this.result = id.filter(item => item.resultState.status==='INCONCLUSIVE')[0].testStepReport;
        // this.map.set('id',id[0].title);
        // let d =this.result.filter(item => item.resultState.status==='INCONCLUSIVE')
        // this.auditLogs =d ;
        // //console.log('result',this.result);
        // //console.log('auditLog', d);
        
        // this.failReasonList = this.indexOfField("INCONCLUSIVE");  
        // var indexLog = this.auditLogs[0].auditInfoS.findIndex(v => v.includes("5001"));  
        // this.failReasonList.push(this.auditLogs[0].auditInfoS[indexLog]);
        // this.failReasonList.push(this.auditLogs.filter(item => item.auditInfoS==='Error:'));
        // this.map.set('faildata',this.failReasonList);
        // let jsonObject = {};  
        // this.map.forEach((value, key) => {  
        //        jsonObject[key] = value  
        // });  
        // let  jsonString = JSON.stringify(jsonObject);
        // this.failReasonList = JSON.parse(jsonString);
        // //console.log('map',this.failReasonList);
        // var ec = this.auditLogs.filter(item => item.auditInfoS==='Error:');
        // //console.log('a',ec);
      },error => {
        //console.log('error',error);
      })
    }
    // //console.log(this.failReasonList, this.failReasonList);
  }else{
    this.failReasonList= [];
  }
  
}
indexOfField = function(field) {
  let indexof: any[]=[];
  this.result.forEach(function(x,index){
    if(x.resultState.status === field){
      indexof.push("Step : " + (index+1) +" Became "+field)      
    }
  })
  return indexof;
}
onPageChange(newValue) {
  this.selectedPage = newValue;
  this.perpageitem = newValue;
}


selectChartType(chartType){
  this.barChartType = chartType;
}

getTestSuiteTestReport(projectid,reportId,testDataId,path,title){
  this.testService.getTestSuiteTestReport(projectid,reportId,testDataId,path,title,this.dataIterationIndex).subscribe(
    data=>{
      this.testSuiteReportData=data;
      //console.log('testCaseSummaryReport', this.testSuiteReportData);
      
      var projectSummary = this.testSuiteReportData;
        let chartObj = new Chart();
        chartObj.pass = projectSummary['pass'];
        chartObj.fail = projectSummary['fail']
        chartObj.blocked = projectSummary['blocked']
        chartObj.inconclusive = projectSummary['inconclusive']
        chartObj.notRun = projectSummary['notRun'];
        chartObj.skipped = projectSummary['skipped'];
        // var total = chartObj.pass + chartObj.fail + chartObj.blocked
        this.chartList.push(chartObj);
      this.barChartLabels = ['Pass','Fail','Blocked','Inconclusive','Not Run','Skipped']
      for(let c of this.chartList){
        this.blinkArry.push(Object.values(c));
      }
      this.numarray = JSON.parse(JSON.stringify(this.blinkArry[0]));
      const toNumbers = arr => arr.map(Number);
       var n = toNumbers(this.numarray);
       this.total = n.reduce((acc, cur) => acc + cur, 0);
      //  //console.log('total',sum);
       
      this.barChartData = [{ data:  n,label: 'Bar Chart' ,backgroundColor: this.barChartColors,hoverBackgroundColor: this.barChartColors,hoverBorderColor: this.barChartColors}];
      
    
    }
  )
}
goBack(event) {
  //console.log('event',event.target.innerHTML);
  var ti = event.target.innerHTML;
  if(ti==='Historical Report'){
    this.router.navigate(['report/testReport/'+this.projectId+'/historical']);
  }else{
    this.router.navigate(['report/testReport/'+this.projectId+'/latest']);
  }
}

copyToClipboard(item,id): void {
  //console.log(item,id)
  var copyItem;
  for (let entry of item) {
    if(entry.key===id){
      // //console.log('Map key is:',entry.value);
      if(entry.value!==null || entry.value!==''){
        copyItem = entry.value;
      }
      
    }
   
}

  this.utils.copyToClipboard(copyItem);
  this.toastrService.clear();
  this.toastrService.success('Copy To Clipboard');
}

showBug(projectId, testProjectReportId, testDataId, testSuiteId, index, dataIterationIndex)
{
  //console.log(index);
 // this.testSuiteReportData['testCaseSummaryReport'][index].bugLogging = 'Auto';
  //console.log(this.testSuiteReportData)
  let obj=
  {
    dataIterationIndex : dataIterationIndex,
    projectId : projectId,
    testDataId : testDataId,
    testProjectReportId : testProjectReportId,
    testSuiteId : testSuiteId
  }
  this.testService.logFailedBug(projectId, testProjectReportId, testDataId, testSuiteId, dataIterationIndex, obj).subscribe((res)=>
  {
      if(res)
      {
        this.testSuiteReportData['testCaseSummaryReport'][index] = res['testCaseSummaryReport'][index];
      }
  })
}




}